import { MoonIcon, SunIcon } from '../icons';
import { ThemeName } from '../../hooks/useTheme';

type ThemeToggleProps = {
  isDarkTheme: boolean;
  onToggle: () => void;
  theme: ThemeName;
};

export function ThemeToggle({ isDarkTheme, onToggle, theme }: ThemeToggleProps) {
  return (
    <button
      aria-label={isDarkTheme ? 'Ativar modo claro' : 'Ativar modo escuro'}
      aria-pressed={isDarkTheme}
      className={`theme-toggle theme-toggle-${theme}`}
      onClick={onToggle}
      type="button"
    >
      <span className="theme-toggle-icon theme-toggle-icon-sun" aria-hidden="true">
        <SunIcon />
      </span>
      <span className="theme-toggle-icon theme-toggle-icon-moon" aria-hidden="true">
        <MoonIcon />
      </span>
      <span className="theme-toggle-knob">{isDarkTheme ? <MoonIcon /> : <SunIcon />}</span>
    </button>
  );
}
